export default {"dropdownLabel":"du54m","dropdownContainer":"Jqw29","arrow":"_4iZhl","arrowOpen":"VbUd4","arrowClose":"c0DHB","hidden":"_0LcY-"};